// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","745":"component---src-pages-privacy-js"}[chunkId] || chunkId) + "-" + {"293":"84d679a5143fca2c359b","454":"3d92724df1613ec7a677","510":"a1fc6cd975bee6f57e81","745":"c734927ef26c4800e2f1"}[chunkId] + ".js";
};